"use client";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Link from "next/link";

const Footer = () => {
  const footerTags = [
    { id: 1, tag: "#VedicKnowledge" },
    { id: 2, tag: "#IndianHeritage" },
    { id: 3, tag: "#SacredGeography" },
    { id: 4, tag: "#TimelessWisdom" },
    { id: 5, tag: "#CulturalLegacy" },
    { id: 6, tag: "#SpiritualJourney" },
    { id: 7, tag: "#AncientIndia" },
    { id: 8, tag: "#Mythology" },
    { id: 9, tag: "#FaithAndDevotion" },
    { id: 10, tag: "#EpicOfIndia" },
  ];

  const [filteData, setFilterData] = useState(footerTags);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setFilterData(footerTags.slice(0, 6));
      } else {
        setFilterData(footerTags);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <footer className="bg-[#2c3e50] text-gray-100 py-12 px-5 md:px-16">
      {/* Tags Grid */}
      <div id="contact" className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-10">
        {filteData.map(({ id, tag }) => (
          <div
            key={id}
            className="border border-yellow-600 rounded-lg p-2 md:p-3 text-center hover:bg-yellow-600/10 transition"
          >
            <h2 className="select-none">{tag}</h2>
          </div>
        ))}
      </div>

      {/* Social Icons */}
      <motion.div
        className="flex justify-center space-x-6 text-2xl mb-8"
        initial={{ opacity: 0, x: -200 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <a
          href="https://facebook.com/yourprofile"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-blue-500 transition"
          aria-label="Visit our Facebook page"
        >
          <FaFacebook />
        </a>
        <a
          href="https://instagram.com/yourprofile"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-pink-500 transition"
          aria-label="Visit our Instagram profile"
        >
          <FaInstagram />
        </a>
        <a
          href="mailto:youremail@example.com"
          className="hover:text-red-500 transition"
          aria-label="Send us an email"
        >
          <MdEmail />
        </a>
        <a
          href="https://linkedin.com/in/yourprofile"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-blue-700 transition"
          aria-label="Visit our LinkedIn profile"
        >
          <FaLinkedin />
        </a>
      </motion.div>

      {/* Navigation Links */}
      <div className="flex justify-center gap-6 mb-6 text-sm uppercase tracking-wide">
        <Link href="#home" className="hover:text-yellow-400 cursor-pointer">
          Home
        </Link>
        <Link href="#origins" className=" hover:text-yellow-400 cursor-pointer">
          Origins
        </Link>
        <Link
          href="#chronicle"
          className="hover:text-yellow-400 cursor-pointer"
        >
          Chronicle
        </Link>
        <Link
          href="#geography"
          className="hover:text-yellow-400 cursor-pointer"
        >
          Geography
        </Link>
      </div>

      {/* Copyright */}
      <p className="text-center text-xs md:text-sm text-gray-200 select-none">
        © 2026 Ramayan Project. All Rights Reserved.
        <span className="font-semibold"> ~KS </span>
      </p>
    </footer>
  );
};

export default Footer;
